"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
require("./RadioInput.scss");
var RadioInput = function (props) {
    var dusk = props.dusk, label = props.label, _a = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _a === void 0 ? true : _a, rest = __rest(props, ["dusk", "label", "allowSubmittingDisabledState"]);
    var isSubmitting = formik_1.useFormikContext().isSubmitting;
    return (react_1.default.createElement("label", { className: "inline-flex items-center mr-4" },
        react_1.default.createElement(formik_1.Field, __assign({ "data-dusk": dusk, className: "form-radio", type: "radio", disabled: isSubmitting && allowSubmittingDisabledState }, rest)),
        label && react_1.default.createElement("span", { className: "pl-2" }, label)));
};
exports.default = RadioInput;
//# sourceMappingURL=index.js.map